import type {Channel} from '@mattermost/types/channels';

import {isDirectChannel} from 'utils/isDirectChannel';

import {isGroupChannel} from 'utils/isGroupChannel';

/**
 * Говорит что это личка или групповой чат
 */
export function isDirectLikeChannel(channel?: Channel) {
    return isDirectChannel(channel) || isGroupChannel(channel);
}
